// helpers/fetchUtils.js

// ✅ General: Comprueba si el objeto (user o athlete.user) tiene un rol
export async function fetchStatusUpdate(token,entity, id, status_id, source) {
    try {
        return await this.$axios.post(`/status/update`, {
            entity: entity,
            id: id,
            new_status: status_id,
            source: source,
        },{
            headers: { Authorization: `Bearer ${token}` },
        });

    } catch (error) {
        const details = error?.response?.data || error;
        console.error("❌ Error al actualizar estado:", details);
        return error;
    }
}